
URL = globalThis.URL
import __vite__wasmUrl from "/Users/tunafish/Documents/Projects/cryptosaka/clorio/clorio_new/clorio-client/node_modules/tiny-secp256k1/lib/secp256k1.wasm?url"
import __vite__initWasm from "/__vite-plugin-wasm-helper"

import { generateInt32 as __vite__wasmImport_0_0 } from "./rand.js";
import { throwError as __vite__wasmImport_1_0 } from "./validate_error.js";
const __vite__wasmModule = await __vite__initWasm({ "./rand.js": { generateInt32: __vite__wasmImport_0_0 }, "./validate_error.js": { throwError: __vite__wasmImport_1_0 } }, __vite__wasmUrl);
export const memory = __vite__wasmModule.memory;
export const initializeContext = __vite__wasmModule.initializeContext;
export const isPoint = __vite__wasmModule.isPoint;
export const PUBLIC_KEY_INPUT = __vite__wasmModule.PUBLIC_KEY_INPUT;
export const pointAdd = __vite__wasmModule.pointAdd;
export const PUBLIC_KEY_INPUT2 = __vite__wasmModule.PUBLIC_KEY_INPUT2;
export const pointAddScalar = __vite__wasmModule.pointAddScalar;
export const TWEAK_INPUT = __vite__wasmModule.TWEAK_INPUT;
export const xOnlyPointAddTweak = __vite__wasmModule.xOnlyPointAddTweak;
export const X_ONLY_PUBLIC_KEY_INPUT = __vite__wasmModule.X_ONLY_PUBLIC_KEY_INPUT;
export const xOnlyPointAddTweakCheck = __vite__wasmModule.xOnlyPointAddTweakCheck;
export const X_ONLY_PUBLIC_KEY_INPUT2 = __vite__wasmModule.X_ONLY_PUBLIC_KEY_INPUT2;
export const pointCompress = __vite__wasmModule.pointCompress;
export const pointFromScalar = __vite__wasmModule.pointFromScalar;
export const PRIVATE_INPUT = __vite__wasmModule.PRIVATE_INPUT;
export const xOnlyPointFromScalar = __vite__wasmModule.xOnlyPointFromScalar;
export const xOnlyPointFromPoint = __vite__wasmModule.xOnlyPointFromPoint;
export const pointMultiply = __vite__wasmModule.pointMultiply;
export const privateAdd = __vite__wasmModule.privateAdd;
export const privateSub = __vite__wasmModule.privateSub;
export const privateNegate = __vite__wasmModule.privateNegate;
export const sign = __vite__wasmModule.sign;
export const HASH_INPUT = __vite__wasmModule.HASH_INPUT;
export const EXTRA_DATA_INPUT = __vite__wasmModule.EXTRA_DATA_INPUT;
export const SIGNATURE_INPUT = __vite__wasmModule.SIGNATURE_INPUT;
export const signRecoverable = __vite__wasmModule.signRecoverable;
export const signSchnorr = __vite__wasmModule.signSchnorr;
export const verify = __vite__wasmModule.verify;
export const recover = __vite__wasmModule.recover;
export const verifySchnorr = __vite__wasmModule.verifySchnorr;
export const rustsecp256k1_v0_8_1_default_error_callback_fn = __vite__wasmModule.rustsecp256k1_v0_8_1_default_error_callback_fn;
export const rustsecp256k1_v0_8_1_default_illegal_callback_fn = __vite__wasmModule.rustsecp256k1_v0_8_1_default_illegal_callback_fn;
export const __data_end = __vite__wasmModule.__data_end;
export const __heap_base = __vite__wasmModule.__heap_base;
